module.exports = __webpack_public_path__ + "static/media/ministry.d3b45ef5.png";